export const FundStructure = {
  Standard: 'Standard',
  ManagedAccountSma: 'ManagedAccountSma',
  MasterFeeder: 'MasterFeeder',
} as const;

export type FundStructure = (typeof FundStructure)[keyof typeof FundStructure];

export const fundStructureSelectOptions: { label: string; value: FundStructure }[] = [
  { label: 'Standard Fund', value: FundStructure.Standard },
  { label: 'Managed Account / SMA', value: FundStructure.ManagedAccountSma },
  { label: 'Master-Feeder Fund', value: FundStructure.MasterFeeder },
];
